module.exports = __webpack_public_path__ + "media/images/icon_answer-65b7f4d18a27b7fb2fea9c71d8d84edf.svg";